
export enum AdapterType {
    Http = "http",
    Sql = "sql",
    Webhook = "webhook",
}
